import { actionTypes as modalsActionTypes } from './modals.actions';

const initialState = {
    isSelectionInfoModalVisible: false,
    globalModal: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case modalsActionTypes.SHOW_SELECTION_INFO_MODAL:
            return {
                ...state,
                isSelectionInfoModalVisible: true,
            };
        case modalsActionTypes.HIDE_SELECTION_INFO_MODAL:
            return {
                ...state,
                isSelectionInfoModalVisible: false,
            };
        case modalsActionTypes.SET_GLOBAL_MODAL:
            return {
                ...state,
                globalModal: {
                    title: action.title,
                    body: action.body,
                    ctaTitle: action.ctaTitle,
                },
            }
        case modalsActionTypes.CLEAR_GLOBAL_MODAL:
            return {
                ...state,
                globalModal: null,
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// /src/js/modals/modals.reducer.js